var Base = require('_js/base'),
  ko = require('knockout');

function CitySearch(params) {
  this.$codeEl = params.codeEl;
  this.$cityEl = params.cityEl;
  this.init();
}

CitySearch.prototype = new Base();

CitySearch.prototype.init = function() {
  var self = this;

  self.$codeEl.keyup(function() {
    self.getInputText();
  });
};

CitySearch.prototype.getInputText = function() {
  var self = this;
  if (self.$codeEl.val().length === 4) {
    self.searchForCity(self.$codeEl.val());
  } else if (self.$codeEl.val().length === 0) {
    // empty city if there is no postcode
    self.$cityEl.val('');
  }
};

CitySearch.prototype.searchForCity = function(num) {
  var self = this;
  $.getJSON(
    'https://fraktguide.bring.no/fraktguide/postalCode.json?pnr=' +
      num +
      '&callback=?',
    function(data) {
      self.$cityEl.val(data.result);
    }
  );
};
function SearchPostalCode() {
  this.init();
}

SearchPostalCode.prototype = new Base();

SearchPostalCode.prototype.init = function() {
  var $postalCodes = $('[data-search-postal-code]');
  if ($postalCodes.get(0) !== undefined) {
    $postalCodes.each(function() {
      ko.applyBindings(
        new CitySearch({
          codeEl: $($(this).find('input.postal-code')),
          cityEl: $($(this).find('input.postal-place'))
        }),
        this
      );
    });
  }
};
module.exports = SearchPostalCode;
